import Swiper, { Autoplay, EffectFade, Navigation, A11y } from 'swiper/core';
Swiper.use([Autoplay, EffectFade, Navigation, A11y]);



var carousels = document.getElementsByClassName("swiper-container-text");

var carouselIncrement = 0;

Array.from(carousels).forEach((element) => {

    var id = element.dataset.id ?? carouselIncrement;
    const prevControllerClass = ".swiper-button-prev-" + id;
    const nextControllerClass = ".swiper-button-next-" + id;


    //Fix for old implemented carousels
    var previousButton = element.getElementsByClassName("swiper-button-prev");
    var nextButton = element.getElementsByClassName("swiper-button-next");

    // Convert swiper-button-prev to swiper-button-prev+id & swiper-button-prev-style, remove swiper-button-prev
    if (previousButton.length != 0 && nextButton.length != 0) {
        previousButton[0].classList.add("swiper-button-prev-" + id);
        nextButton[0].classList.add("swiper-button-next-" + id);
        previousButton[0].classList.add("swiper-button-prev-style");
        nextButton[0].classList.add("swiper-button-next-style");
        previousButton[0].classList.remove("swiper-button-prev");
        nextButton[0].classList.remove("swiper-button-next");
    }
    // Optional parameters
    var swiperConfig = {
        slidesPerView: 'auto',
        speed: 300,
        effect: 'fade',
        navigation: {
            prevEl: prevControllerClass,
            nextEl: nextControllerClass
        },
        fadeEffect: {
            crossFade: true
        },
        breakpoints: {
            768: {
                spaceBetween: 49
            }
        }
    }

    var swiper = new Swiper(element, swiperConfig);
    carouselIncrement = carouselIncrement++;
});